<template>
    <div v-if="property">
        <h4 class="title is-5">
            Brochures
        </h4>

        <Notification v-if="! brochures && ! hasBrochures">
            Loading brochures...
        </Notification>

        <Notification v-if="brochures && ! hasBrochures">
            No brochures available
        </Notification>

        <p>
            <span
                v-for="(brochure, index) in brochures"
                :key="brochure.UploadDocumentPK"
                class="mr-2"
            >
                <b-button
                    tag="a"
                    :href="brochure.SignedUrl"
                    icon-left="cloud-download-alt"
                >
                    Brochure #{{ index + 1 }}
                </b-button>
            </span>
        </p>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Notification from './Notification';

export default {
    components: {
        Notification,
    },

    computed: {
        ...mapState('salesProperty', [
            'property',
            'brochures',
        ]),
        ...mapGetters('salesProperty', [
            'hasBrochures',
        ]),
    },

    mounted() {
        this.$store.dispatch('salesProperty/getBrochures', this.$route.params.id);
    },
};
</script>
